export default class PdfReport {
  public page: number = 1;
  public numPages: number = 0;
  public errors: string[] = [];
  public scale: string = "page-width";
  public pdfData: any = "";
  public src: string = "";
  public titre: string = "";
  public dates: string = "";
}
